package org.example.project.model

import kotlinx.serialization.Serializable

/**
 * 支付记录响应模型
 */
@Serializable
data class PaymentResponse(
 val code: Int,
 val message: String,
 val data: PaymentRecord?
)

/**
 * 支付记录模型
 * 根据实际API响应，部分字段可能不返回，设置为可选
 */
@Serializable
data class PaymentRecord(
 val paymentId: Int? = null,
 val userId: Int? = null,
 val orderNo: String? = null,
 val amount: Double? = null,
 val paymentMethod: String? = null,
 val paymentTime: String? = null,
 val paymentStatus: Int? = null
)

/**
 * 支付宝支付响应模型（标准RESTful格式）
 */
@Serializable
data class AlipayResponse(
 val code: Int,
 val message: String? = null,
 val data: AlipayData? = null,
 // 兼容易支付格式（顶层字段）
 val msg: String? = null,
 val trade_no: String? = null,
 val orderNo: String? = null,  // 订单号（充值/升级管理员接口使用）
 val O_id: String? = null,
 val payurl: String? = null,
 val payurl2: String? = null,
 val qrcode: String? = null,
 val img: String? = null
)

/**
 * 支付宝支付数据模型
 */
@Serializable
data class AlipayData(
 val trade_no: String? = null,
 val orderNo: String? = null,
 val payurl: String? = null,
 val payurl2: String? = null,
 val qrcode: String? = null,
 val img: String? = null,
 val amount: Double? = null
)